import React, { useEffect, useRef, useState } from 'react';
import { createField } from './field';

// Adds empty vgs collect field
// useful when submitting a form that has no vgs collect input fields
export default function VgsCollectShim({
  form,
}: {
  form: VGSForm<unknown>;
}): JSX.Element {
  const elRef = useRef<HTMLDivElement>(null);
  const [field, setField] = useState<VGSField>();

  useEffect(() => {
    if (
      field !== undefined ||
      elRef.current === undefined ||
      form.fields.some((f) => f.name === 'shim')
    ) {
      return;
    }

    setField(
      createField(
        'text',
        [],
        form,
        elRef,
        'shim',
        undefined,
        undefined,
        {
          visibility: 'hidden',
        },
        undefined,
      ),
    );
  }, [field, form]);

  return (
    <div
      className='vgs-ref overflow-hidden'
      ref={elRef}
      style={{
        height: 0,
      }}
    ></div>
  );
}
